module.exports = __webpack_public_path__ + "static/191016-BS-IGB-HM-Blade-n-Ghoul-RNG-2-68fbca698a87163e68897a3f3386e333.jpg";